// @ts-ignore
import * as errorToolTip from '../general/errorToolTip';
import { TooltipDirection } from '../general/newErrorToolTip';

export class LoginFormContent {
    private form: JQuery<HTMLElement>;
    private showTooltipOnLeft: boolean;

    public constructor(
        form: JQuery<HTMLElement>,
        tooltipDirection: string
    ) {
        this.form = form;
        this.showTooltipOnLeft = tooltipDirection.toLowerCase() === 'right';
    }


    public static fromForm(form: JQuery<HTMLElement>, tooltipDirection: TooltipDirection) {
        return new LoginFormContent(
            form,
            tooltipDirection
        );
    }

    public showEmailError(message: string) {
        const emailInputParent = this.getEmailInputParent();
        emailInputParent.addClass('error');
        errorToolTip(emailInputParent, this.showTooltipOnLeft, message);
    }

    public showPasswordError(message: string) {
        const passwordInputParent = this.getPasswordInputParent();
        passwordInputParent.addClass('error');
        errorToolTip(passwordInputParent, this.showTooltipOnLeft, message);
    }

    public showSubmitButtonError(message: string) {
        const submitButton = this.getSubmitButton();
        errorToolTip(submitButton, this.showTooltipOnLeft, message);
    }

    public hideErrors() {
        this.getEmailInputParent().removeClass('error');
        this.getPasswordInputParent().removeClass('error');
    }

    private getEmailInputParent() {
        return $('input[name=email]', this.form).parent();
    }

    private getPasswordInputParent() {
        return $('input[name=password]', this.form).parent();
    }

    private getSubmitButton() {
        return $('button[type=submit]', this.form).parent();
    }
}
